import { motion } from "motion/react";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const navLinks = [
  { name: "About", id: "about" },
  { name: "Work", id: "projects" },
  { name: "Let's Connect", id: "contact" },
];

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setIsOpen(false);
    const element = document.querySelector(`[data-section="${id}"]`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 z-50 w-full bg-background/70 backdrop-blur-xl border-b border-border/50"
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-24">
          <motion.a
            href="#"
            className="text-xl text-foreground font-bold"
            whileHover={{ opacity: 0.7 }}
          >
            Peter.A
          </motion.a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-12 text-lg">
            {navLinks.map((link, index) => (
              <motion.button
                key={index}
                onClick={() => scrollToSection(link.id)}
                className="relative rounded-none group"
                initial={{ opacity: 0, y: -20 }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{ delay: index * 0.1 }}
                whileHover={
                  link.name === "Contact" // Keep string matching for the hover animation
                    ? {
                        scale: 1.02,
                      }
                    : {}
                }
                whileTap={{
                  y: 1,
                  scale: 0.985,
                }}
              >
                {link.id === "contact" ? (
                  <>
                    <span className="relative block px-5 py-2 bg-blue-500 text-white font-medium hover:bg-blue-600 transition-all hover:-translate-y-px rounded-2xl">
                      {link.name}
                    </span>
                  </>
                ) : (
                  <span className="text-muted-foreground hover:text-foreground transition-colors">
                    {link.name}
                  </span>
                )}
              </motion.button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <motion.button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-foreground"
            whileTap={{ scale: 0.95 }}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </motion.button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <motion.div
        initial={false}
        animate={{ height: isOpen ? "auto" : 0 }}
        className="md:hidden overflow-hidden border-t border-border/50 mt-px"
      >
        <div className="container mx-auto px-6 py-6 space-y-4">
          {navLinks.map((link, index) => (
            <motion.button
              key={index}
              onClick={() => scrollToSection(link.id)}
              className="block text-left w-full text-muted-foreground hover:text-foreground transition-colors py-2"
              initial={{ opacity: 0, x: -20 }}
              animate={{
                opacity: isOpen ? 1 : 0,
                x: isOpen ? 0 : -20,
              }}
              transition={{ delay: index * 0.05 }}
            >
              {link.name}
            </motion.button>
          ))}
        </div>
      </motion.div>
    </motion.nav>
  );
}
